import { getJson, patchJson, postJson } from './APIClient';

export const get = () => getJson('/v1/account/hair_profile/');

export const patch = data => patchJson('/v1/account/hair_profile/', data);

export const fetchAggressors = () => getJson('/v1/account/hair_profile/aggressors');

export const fetchScoring = () => getJson('/v1/account/hair_profile/scoring');

export const fetchFragrances = async () => {
  const results = await getJson('/v1/account/hair_profile/fragrances');
  return results.fragrances;
};

export const fetchFragrancesFeedback = async () => {
  const results = await getJson('/v1/account/hair_profile/fragrances?use_feedback=true');
  return results.fragrances;
};

export const fetchIngredients = () => getJson('/v1/account/hair_profile/ingredients');

export const fetchPrescription = () => getJson('/v1/account/hair_profile/prescription');

export const fetchRoutine = () => getJson('/v1/account/your_routine');
export const fetchAllIngredients = () => getJson('/v1/ingredients');
export const postRoutine = data => postJson('/v1/account/your_routine', data);
